import messages from '../../messages'
import {
  TubeProperties,
  Modification,
} from '@src/routes/Configurators/utils/enum'
import { DefaultValue } from '../../products/BiTube/enum'

interface ModificationDropDownData {
  label: string
  value: string
  order: string
  disabled?: boolean
}

const modificationDropDownData: ModificationDropDownData = {
  label: '',
  value: '',
  order: '',
  disabled: false,
}

enum modificationConstant {
  ALL = 'ALL',
  internalMod = 'internalMod',
  Analog = 'Analog',
  label = 'label',
  fiveMod = 'fiveMod',
  fluorescent = 'fluorescent',
  threeMod = 'threeMod',
  order = 'order',
}

export const modificationType = (
  modificationType: string,
  modificationResponseData: any
): any => {
  const dropDownList = [modificationDropDownData]

  dropDownList.length = 0
  modificationResponseData.modifications.forEach((modification) => {
    if (modification.modificationType === modificationType) {
      modification.category.forEach((mod) => {
        // intl.formatMessage({...messages[`${`CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE`}`]}
        //For label value should get it from the Propery File insted from the response.

        modificationDropDownData.label = mod.categoryName
        modificationDropDownData.value = mod.categoryName
        dropDownList.push({ ...modificationDropDownData })
      })
    }
  })

  return dropDownList
}

export const modificationTypeWithPropertyKeys = (
  modificationType: string,
  modificationResponseData: any
): any => {
  const dropDownList = [modificationDropDownData]

  dropDownList.length = 0
  modificationResponseData.modifications.forEach((modification) => {
    if (modification.modificationType === modificationType) {
      modification.category.forEach((mod) => {
        modificationDropDownData.label =
          messages[mod.categoryDisplayName]?.defaultMessage ||
          mod.categoryDisplayName
        modificationDropDownData.value = mod.categoryName
        dropDownList.push({ ...modificationDropDownData })
      })
    }
  })

  return dropDownList
}

export const modificationTypeValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData,
  isLNABaseEnable?: boolean | null
) => {
  const dropDownList = [modificationDropDownData]
  dropDownList.length = 0
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        if (
          category.categoryName === categoryTypeValue ||
          categoryTypeValue === 'ALL'
        ) {
          category.modifications.forEach((categoryValue) => {
            // For label value should get it from the Property File instead from the response.
            modificationDropDownData.label = categoryValue.displayName
            modificationDropDownData.value = categoryValue.value

            modificationDropDownData.disabled =
              categoryTypeValue === 'LNA Bases' && isLNABaseEnable === false

            dropDownList.push({ ...modificationDropDownData })
          })
        }
      })
    }
  })

  return dropDownList
}
export const modificationTypeValueWithProperties = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData,
  modificationList?
) => {
  const dropDownList = [modificationDropDownData]

  dropDownList.length = 0
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        if (category.categoryName === categoryTypeValue) {
          category.modifications.forEach((categoryValue) => {
            ////For label value should get it from the Propery File insted from the response.
            if (modificationList && modificationList.length !== 0) {
              if (modificationList.includes(categoryValue.value)) {
                modificationDropDownData.label =
                  messages[categoryValue.displayName]?.defaultMessage ||
                  categoryValue.displayName
                modificationDropDownData.value = categoryValue.value
                dropDownList.push({ ...modificationDropDownData })
              }
            } else {
              modificationDropDownData.label =
                messages[categoryValue.displayName]?.defaultMessage ||
                categoryValue.displayName
              modificationDropDownData.value = categoryValue.value
              dropDownList.push({ ...modificationDropDownData })
            }
          })
        }
      })
    }
  })

  return dropDownList
}

export const modificationTypeValueForDropdowns = (
  categoryType: string,
  specificationsData
) => {
  const dropDownList = [modificationDropDownData]

  dropDownList.length = 0
  if (specificationsData) {
    specificationsData.specifications.forEach((specifications) => {
      if (specifications.categoryName === categoryType) {
        specifications.specificationModifications.forEach((category) => {
          modificationDropDownData.label =
            messages[category.displayName]?.defaultMessage ||
            category.displayName
          modificationDropDownData.value = category.value
          dropDownList.push({ ...modificationDropDownData })
        })
      }
    })
  }
  return dropDownList
}
export const daughterPlatesOptions = (daughterPlateRange) => {
  const dropDownList = [modificationDropDownData]
  dropDownList.length = 0
  if (daughterPlateRange >= 0) {
    for (let i = 0; i <= daughterPlateRange; i++) {
      modificationDropDownData.label = i.toString()
      modificationDropDownData.value = i.toString()
      dropDownList.push({ ...modificationDropDownData })
    }
  }
  return dropDownList
}

export const dropDownValuesForCustomCrispr = (
  categoryType: string,
  specificationsData,
  dropDownValuesFromResponse
) => {
  const dropDownList = [modificationDropDownData]

  dropDownList.length = 0
  if (specificationsData && dropDownValuesFromResponse) {
    specificationsData.specifications.forEach((specifications) => {
      if (specifications.categoryName === categoryType) {
        for (const dropDownValue in dropDownValuesFromResponse) {
          specifications.specificationModifications.forEach((category) => {
            if (category.value === dropDownValuesFromResponse[dropDownValue]) {
              modificationDropDownData.label =
                messages[category.displayName]?.defaultMessage ||
                category.displayName
              modificationDropDownData.value = category.value
              dropDownList.push({ ...modificationDropDownData })
            }
          })
        }
      }
    })
  }
  return dropDownList
}

export const setStandardTubeModificationData = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData
) => {
  let dropDownList = [modificationDropDownData]
  const internalModAnalogList: any = []
  const internalModList: any = []
  const fiveModFluorescentList: any = []
  const fiveModList: any = []
  const threeModFluorescentList: any = []
  const threeModList: any = []

  dropDownList.length = 0
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        if (category.categoryName === categoryTypeValue) {
          category.modifications.forEach((categoryValue) => {
            ////For label value should get it from the Propery File insted from the response.
            modificationDropDownData.label = categoryValue.displayName
            modificationDropDownData.value = categoryValue.value
            modificationDropDownData.order = categoryValue.order
            dropDownList.push({ ...modificationDropDownData })
          })
        } else if (categoryTypeValue === modificationConstant.ALL) {
          if (categoryType === modificationConstant.internalMod) {
            category.modifications.forEach((categoryValue) => {
              if (category.categoryName === modificationConstant.Analog) {
                modificationDropDownData.label = categoryValue.displayName
                modificationDropDownData.value = categoryValue.value
                modificationDropDownData.order = categoryValue.order
                internalModAnalogList.push({ ...modificationDropDownData })
              } else {
                modificationDropDownData.label = categoryValue.displayName
                modificationDropDownData.value = categoryValue.value
                modificationDropDownData.order = categoryValue.order
                internalModList.push({ ...modificationDropDownData })
              }

              dropDownList = [...internalModAnalogList, ...internalModList]
            })
          }
          if (categoryType === modificationConstant.fiveMod) {
            category.modifications.forEach((categoryValue) => {
              if (category.categoryName === modificationConstant.fluorescent) {
                modificationDropDownData.label = categoryValue.displayName
                modificationDropDownData.value = categoryValue.value
                modificationDropDownData.order = categoryValue.order
                fiveModFluorescentList.push({ ...modificationDropDownData })
              } else {
                modificationDropDownData.label = categoryValue.displayName
                modificationDropDownData.value = categoryValue.value
                modificationDropDownData.order = categoryValue.order
                fiveModList.push({ ...modificationDropDownData })
              }

              dropDownList = [...fiveModFluorescentList, ...fiveModList]
            })
          }
          if (categoryType === modificationConstant.threeMod) {
            category.modifications.forEach((categoryValue) => {
              if (category.categoryName === modificationConstant.fluorescent) {
                modificationDropDownData.label = categoryValue.displayName
                modificationDropDownData.value = categoryValue.value
                modificationDropDownData.order = categoryValue.order
                threeModFluorescentList.push({ ...modificationDropDownData })
              } else {
                modificationDropDownData.label = categoryValue.displayName
                modificationDropDownData.value = categoryValue.value
                modificationDropDownData.order = categoryValue.order
                threeModList.push({ ...modificationDropDownData })
              }

              dropDownList = [...threeModFluorescentList, ...threeModList]
            })
          }
        }
      })
    }
  })

  return dropDownList
}

export const getALLValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData,
  errorResponseJson,
  isOverridden
) => {
  let dropDownList = [modificationDropDownData]
  dropDownList.length = 0
  const list = setStandardTubeModificationData(
    categoryType,
    categoryTypeValue,
    modificationResponseData
  )
  if (isOverridden) {
    list.forEach((data) => {
      modificationDropDownData.label =
        messages[data.label]?.defaultMessage || data.label
      modificationDropDownData.value = data.value
      modificationDropDownData.order = data.order
      dropDownList.push({ ...modificationDropDownData })
    })
    return dropDownList
  }

  if (Object.keys(errorResponseJson).length !== 0) {
    list.forEach((data) => {
      if (
        categoryType === modificationConstant.fiveMod &&
        errorResponseJson.listFiveMod !== null
      ) {
        if (errorResponseJson.listFiveMod.includes(data.value)) {
          modificationDropDownData.label =
            messages[data.label]?.defaultMessage || data.label
          modificationDropDownData.value = data.value
          modificationDropDownData.order = data.order
          dropDownList.push({ ...modificationDropDownData })
          if (categoryTypeValue === modificationConstant.ALL) {
            const sortedModData = dropDownList.sort(function (a, b) {
              return Number(a.order) - Number(b.order)
            })
            dropDownList = [...sortedModData]
          }
        } else {
          return list
        }
      } else if (
        errorResponseJson.listThreeMod !== null &&
        categoryType === modificationConstant.threeMod
      ) {
        if (errorResponseJson.listThreeMod.includes(data.value)) {
          modificationDropDownData.label =
            messages[data.label]?.defaultMessage || data.label
          modificationDropDownData.value = data.value
          modificationDropDownData.order = data.order
          dropDownList.push({ ...modificationDropDownData })
          if (categoryTypeValue === modificationConstant.ALL) {
            const sortedModData = dropDownList.sort(function (a, b) {
              return Number(a.order) - Number(b.order)
            })
            dropDownList = [...sortedModData]
          }
        } else {
          return list
        }
      } else if (
        categoryType === modificationConstant.internalMod &&
        errorResponseJson.listInternalMod !== null
      ) {
        if (errorResponseJson.listInternalMod.includes(data.value)) {
          modificationDropDownData.label =
            messages[data.label]?.defaultMessage || data.label
          modificationDropDownData.value = data.value
          modificationDropDownData.order = data.order
          dropDownList.push({ ...modificationDropDownData })

          if (categoryTypeValue === modificationConstant.ALL) {
            const sortedModData = dropDownList.sort(function (a, b) {
              return Number(a.order) - Number(b.order)
            })
            dropDownList = [...sortedModData]
          }
        } else {
          return list
        }
      } else {
        return list
      }
      return list
    })
    return dropDownList
  } else {
    list.forEach((data) => {
      modificationDropDownData.label =
        messages[data.label]?.defaultMessage || data.label
      modificationDropDownData.value = data.value
      dropDownList.push({ ...modificationDropDownData })
    })
    return dropDownList
  }
}
export const getNterminalDefaultValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData
) => {
  let nTerminalDefaultValue = ''
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        if (category.categoryName === categoryTypeValue) {
          category.modifications.forEach((modificationName) => {
            if (modificationName.value === TubeProperties.DefaultNTerminal) {
              nTerminalDefaultValue = modificationName.value
            }
          })
        }
      })
    }
  })
  return nTerminalDefaultValue
}
export const getCterminalDefaultValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData
) => {
  let cTerminalDefaultValue = ''
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        if (category.categoryName === categoryTypeValue) {
          category.modifications.forEach((modificationName) => {
            if (modificationName.value === TubeProperties.DefaultCTerminal) {
              cTerminalDefaultValue = modificationName.value
            }
          })
        }
      })
    }
  })
  return cTerminalDefaultValue
}

export const getDefaultRNAModValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData
) => {
  let defaultRnaModValue = ''
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        if (category.categoryName === categoryTypeValue) {
          category.modifications.forEach((modificationName) => {
            if (modificationName.value === Modification.DefaultRnaMod) {
              defaultRnaModValue = modificationName.value
            }
          })
        }
      })
    }
  })
  return defaultRnaModValue
}

export const getOverhangValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData,
  errorResponseJson
) => {
  const dropDownList = [modificationDropDownData]
  const list: any = []
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        category.modifications.forEach((categoryValue) => {
          ////For label value should get it from the Propery File insted from the response.
          modificationDropDownData.label =
            messages[categoryValue.displayName]?.defaultMessage ||
            categoryValue.displayName
          modificationDropDownData.value = categoryValue.value
          list.push({ ...modificationDropDownData })
        })
      })
    }
  })
  dropDownList.length = 0
  if (
    Object.keys(errorResponseJson).length !== 0 &&
    errorResponseJson.listOverhang
  ) {
    list.forEach((data) => {
      if (errorResponseJson.listOverhang?.includes(data.value)) {
        modificationDropDownData.label = data.label
        modificationDropDownData.value = data.value
        dropDownList.push({ ...modificationDropDownData })
      }
      return list
    })
    return dropDownList
  }
  return list
}

export const getFiveModValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData,
  errorResponseJson
) => {
  const dropDownList = [modificationDropDownData]
  const list = modificationTypeValueWithProperties(
    categoryType,
    categoryTypeValue,
    modificationResponseData
  )
  dropDownList.length = 0
  if (
    Object.keys(errorResponseJson).length !== 0 &&
    errorResponseJson.listFiveMod
  ) {
    list.forEach((data) => {
      if (errorResponseJson.listFiveMod?.includes(data.value)) {
        modificationDropDownData.label = data.label
        modificationDropDownData.value = data.value
        dropDownList.push({ ...modificationDropDownData })
      }
      return list
    })
    return dropDownList
  }
  return list
}

export const getThreeModValue = (
  categoryType: string,
  categoryTypeValue: string,
  modificationResponseData,
  errorResponseJson
) => {
  const dropDownList = [modificationDropDownData]
  const list = modificationTypeValueWithProperties(
    categoryType,
    categoryTypeValue,
    modificationResponseData
  )
  dropDownList.length = 0
  if (
    Object.keys(errorResponseJson).length !== 0 &&
    errorResponseJson.listThreeMod
  ) {
    list.forEach((data) => {
      if (errorResponseJson.listThreeMod?.includes(data.value)) {
        modificationDropDownData.label = data.label
        modificationDropDownData.value = data.value
        dropDownList.push({ ...modificationDropDownData })
      }
      return list
    })
    return dropDownList
  }
  return list
}

export const modificationTypeBaseValue = (
  categoryType: string,

  modificationResponseData
) => {
  const dropDownList = [modificationDropDownData]

  dropDownList.length = 0
  modificationResponseData.modifications.forEach((modifications) => {
    if (modifications.modificationType === categoryType) {
      modifications.category.forEach((category) => {
        category.modifications.forEach((categoryValue) => {
          ////For label value should get it from the Propery File insted from the response.
          modificationDropDownData.label =
            messages[categoryValue.displayName?.replace(/[^a-zA-Z0-9]/g, '_')]
              ?.defaultMessage ||
            categoryValue.displayName?.replace(/[^a-zA-Z0-9]/g, '_')
          modificationDropDownData.value = categoryValue.value
          modificationDropDownData.value = categoryValue.value
          dropDownList.push({ ...modificationDropDownData })
        })
      })
    }
  })
  return dropDownList
}

export const getBaseValue = (
  categoryType: string,

  modificationResponseData
) => {
  const dropDownList = [modificationDropDownData]
  const list = modificationTypeBaseValue(
    categoryType,

    modificationResponseData
  )
  dropDownList.length = 0

  list.forEach((data) => {
    modificationDropDownData.label = data.label
    modificationDropDownData.value = data.value
    dropDownList.push({ ...modificationDropDownData })
  })
  return dropDownList
}

export const getOverhangDisplayValue = (
  modificationResponseData,
  overHangVal
) => {
  let overhangLabel = overHangVal
  if (modificationResponseData?.modifications) {
    modificationResponseData.modifications.forEach((modifications) => {
      if (modifications.modificationType === DefaultValue.OverHang) {
        modifications.category.forEach((category) => {
          category.modifications.forEach((categoryValue) => {
            ////For label value should get it from the Propery File insted from the response.
            if (overHangVal === categoryValue.value)
              overhangLabel =
                messages[categoryValue.displayName]?.defaultMessage ||
                categoryValue.displayName
          })
        })
      }
    })
  }
  return overhangLabel
}
